//#region redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { DialogEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { DialogProps } from "models/propTypes/dialogPropTypes";
//#endregion
//#region components
import { RouteBreadCrumb } from "components/common";
import CreateCustomerDialogContent from "./createCustomerDialog";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useCreateCustomerDialog() {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const getPreviewDialog = (
    customerName?: string,
    onPreviewSubmitSuccess?: (customerId?: number, customerName?: string, orgNr?: string) => void,
    onPreviewDialogClosed?: () => void
  ): DialogProps => {
    return {
      isOpen: false,
      title: (
        <RouteBreadCrumb
          current={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.CreateClient)}
          showHome
        />
      ),
      dialogType: DialogEnums.DialogType.FullScreenNoSpeedDial,
      setDialogRef: true,
      children: (
        <CreateCustomerDialogContent
          customerName={customerName}
          onFormSubmitSuccess={onPreviewSubmitSuccess}
        ></CreateCustomerDialogContent>
      ),
      onClose: onPreviewDialogClosed,
      maxWidth: "sm",
    };
  };

  const showPreviewDialog = async (
    customerName?: string,
    onPreviewSubmitSuccess?: (customerId?: number, customerName?: string) => void,
    onPreviewDialogClosed?: () => void
  ) => {
    dispatch(displayDialog(getPreviewDialog(customerName, onPreviewSubmitSuccess, onPreviewDialogClosed)));
  };

  return { showPreviewDialog };
}

export default useCreateCustomerDialog;
